<div class="form-history-modal">
	<button type="button" class="close-button" aria-label="Close" (click)="close()">&times;</button>

	<header class="modal-header">
		<div>
			<h4>Form Timeline</h4>
			<p class="modal-subtitle">✨ AI-generated account of what has happened to this form.</p>
		</div>
	</header>

	<section class="modal-body">
		<!-- Loading state -->
		<div class="history-loading" *ngIf="isLoading" role="status" aria-live="polite">
			<div class="ai-loading">
				<div class="ai-loading-header">
					<div class="ai-orb" aria-hidden="true"></div>

					<div class="ai-loading-text">
						<div class="ai-loading-title">Analyzing form history</div>
						<div class="ai-loading-subtitle" id="aiLoadingMsg">{{ loadingMessage }}</div>
					</div>
				</div>

				<div class="ai-progress" aria-hidden="true">
					<div class="ai-progress-bar"></div>
				</div>

				<div class="ai-skeleton" aria-hidden="true">
					<div class="sk-card">
						<div class="sk-line w40"></div>
						<div class="sk-line w70"></div>
						<div class="sk-line w90"></div>
						<div class="sk-line w60"></div>
					</div>

					<div class="sk-card">
						<div class="sk-line w35"></div>
						<div class="sk-line w65"></div>
						<div class="sk-line w80"></div>
					</div>
				</div>

				<div class="ai-loading-footnote">This may take a few seconds.</div>
			</div>
		</div>

		<!-- Empty state (when not loading and summary is empty) -->
		<div class="history-empty" *ngIf="!isLoading && (!summary || summary.trim().length === 0)">
			<div class="empty-card" role="status" aria-live="polite">
				<div class="empty-icon" aria-hidden="true">✨</div>
				<div class="empty-title">Nothing recorded yet</div>
				<div class="empty-subtitle">No updates or approval activity have been recorded for this form.</div>
			</div>
		</div>

		<!-- Content -->
		<div
			class="history-content"
			*ngIf="!isLoading && summary && summary.trim().length > 0"
			[innerHTML]="sanitizedSummary"
		></div>
	</section>
</div>
